// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles-module__heading___3k29b","job-posts-container":"styles-module__job-posts-container___3-40V"};